import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20elegant%20luxurious%20background%20with%20golden%20geometric%20patterns%20and%20soft%20bokeh%20lights%2C%20abstract%20luxury%20atmosphere%2C%20warm%20golden%20and%20dark%20amber%20tones%2C%20clean%20minimal%20design%2C%20high%20end%20premium%20background%20texture%2C%20no%20text%20no%20people&width=1800&height=900&seq=hero-bg-macau&orientation=landscape"
          alt="澳门彩官方指南背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
          <span className="text-xs text-accent-200 font-medium">澳门特别行政区合法彩票</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight font-heading">
          澳门彩官方指南
        </h1>

        <p className="text-base md:text-lg text-background-200/90 mb-3 max-w-2xl mx-auto leading-relaxed">
          澳门彩玩法规则全解析 — 开奖结果、购买技巧与中奖攻略一站式掌握
        </p>
        <p className="text-sm text-background-300/80 mb-8 max-w-xl mx-auto leading-relaxed">
          帮助彩民全面了解澳门彩，理性参与、安全购彩，掌握最新开奖资讯与兑奖须知
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/wanfa-guize"
            className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line mr-2"></i>了解玩法规则
          </Link>
          <Link
            to="/category/kaijiang-jieguo"
            className="px-6 py-3 rounded-lg bg-background-50/15 text-background-50 border border-background-50/25 font-medium text-sm hover:bg-background-50/25 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-numbers-line mr-2"></i>查看开奖结果
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 rounded-lg bg-background-50/15 text-background-50 border border-background-50/25 font-medium text-sm hover:bg-background-50/25 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line mr-2"></i>关于我们
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}